<template>
    <div class="px-2">
        <a :href="helpLink"
            class="class"
            target="blank"
            rel="noopener noreferrer">
            {{helpLinkText}}    
        </a>
    </div>
</template>
<script>
export default {
    props : {
        helpLink: {
            default: null
        },
        helpLinkText: {
            default: "View Instructions"
        },
        class:{
            default: null
        }
    }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/framework/primitives/AmfHelpLink.vue